module.exports = __webpack_public_path__ + "img/personas-mobile-en.a153b163.png";